import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import ScrollToTop from "@/components/ScrollToTop";
import ThemeManager from "@/components/ThemeManager";

// Public pages
import Home from "@/pages/Home";
import Sophrologie from "@/pages/Sophrologie";
import Accompagnements from "@/pages/Accompagnements";
import Tarifs from "@/pages/Tarifs";
import APropos from "@/pages/APropos";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import RendezVous from "@/pages/RendezVous";
import Contact from "@/pages/Contact";
import VCardPage from "@/pages/VCardPage";
import Layout from "@/components/Layout";

// Admin pages
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import GestionArticles from "@/pages/admin/GestionArticles";
import GestionTemoignages from "@/pages/admin/GestionTemoignages";
import GestionFAQ from "@/pages/admin/GestionFAQ";
import GestionPages from "@/pages/admin/GestionPages";
import GestionMedia from "@/pages/admin/GestionMedia";
import GestionMessagerie from "@/pages/admin/GestionMessagerie";
import GestionVCard from "@/pages/admin/GestionVCard";
import GestionUtilisateurs from "@/pages/admin/GestionUtilisateurs";
import Parametres from "@/pages/admin/Parametres";
import GestionThemes from "@/pages/admin/GestionThemes";
import GestionTarifs from "@/pages/admin/GestionTarifs";
import { People, Person } from "@/pages/admin/Activity";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-bone-light flex items-center justify-center"><div className="w-8 h-8 border-2 border-sage border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ThemeManager />
        <BrowserRouter>
          <ScrollToTop />
          <Toaster richColors position="top-right" />
          <Routes>
            {/* Public routes */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/sophrologie-caycedienne" element={<Sophrologie />} />
              <Route path="/accompagnements" element={<Accompagnements />} />
              <Route path="/developpement-personnel" element={<Accompagnements />} />
              <Route path="/seances-tarifs" element={<Tarifs />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/prendre-rendez-vous" element={<RendezVous />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/vCard/:slug" element={<VCardPage />} />
            {/* Admin routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="articles" element={<GestionArticles />} />
              <Route path="temoignages" element={<GestionTemoignages />} />
              <Route path="faq" element={<GestionFAQ />} />
              <Route path="pages" element={<GestionPages />} />
              <Route path="media" element={<GestionMedia />} />
              <Route path="messagerie" element={<GestionMessagerie />} />
              <Route path="vCard" element={<GestionVCard />} />
              <Route path="themes" element={<GestionThemes />} />
              <Route path="utilisateurs" element={<GestionUtilisateurs />} />
              <Route path="parametres" element={<Parametres />} />
              <Route path="personnes" element={<People />} />
              <Route path="personnes/:id" element={<Person />} />
              <Route path="tarifs" element={<GestionTarifs />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
